import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { useApp } from "../context/AppContext";
import { LOGO, OWNER_EMAIL, WHATSAPP_NUMBER } from "../lib/constants";

export default function Footer() {
  const { t } = useApp();
  return (
    <footer className="relative bg-black border-t border-[var(--border)] overflow-hidden">
      <div className="purple-radial absolute inset-0 opacity-60 pointer-events-none" />
      <div className="relative max-w-[1500px] mx-auto px-5 md:px-10 pt-24 pb-12">
        <Link to="/book" data-testid="footer-cta" className="group block">
          <h2 className="font-serif font-light leading-none tracking-tighter text-[15vw] md:text-[11vw] text-white group-hover:text-[var(--gold)] transition-colors duration-500">
            LET'S GO.
          </h2>
        </Link>

        <div className="grid md:grid-cols-4 gap-10 mt-20 border-t border-[var(--border)] pt-14">
          <div className="md:col-span-1">
            <img src={LOGO} alt="HRH" className="h-16 w-16 object-contain mb-4" />
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">{t.footer.tagline}</p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.25em] text-[var(--gold)] mb-5">{t.footer.quick}</h4>
            <ul className="space-y-3 text-sm text-white/60">
              <li><Link to="/book" className="hover:text-white transition-colors">{t.nav.book}</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">{t.nav.contact}</Link></li>
              <li><Link to="/" className="hover:text-white transition-colors">{t.nav.destinations}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.25em] text-[var(--gold)] mb-5">{t.footer.legal}</h4>
            <ul className="space-y-3 text-sm text-white/60">
              <li><Link to="/terms" className="hover:text-white transition-colors" data-testid="footer-terms">{t.footer.terms}</Link></li>
              <li><Link to="/privacy" className="hover:text-white transition-colors" data-testid="footer-privacy">{t.footer.privacy}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.25em] text-[var(--gold)] mb-5">{t.footer.contact}</h4>
            <ul className="space-y-3 text-sm text-white/60">
              <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[var(--gold)]/70" /><a href={`mailto:${OWNER_EMAIL}`} className="hover:text-white transition-colors">{OWNER_EMAIL}</a></li>
              <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[var(--gold)]/70" /><a href={`https://wa.me/${WHATSAPP_NUMBER}`} className="hover:text-white transition-colors">+52 56 3629 8441</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/35 tracking-wider">
          <span>© {new Date().getFullYear()} HRH RIVIERA MAYA CANCUN. {t.footer.rights}</span>
          <Link to="/admin/login" className="hover:text-white/60 transition-colors" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
